import type { FirestoreInventoryItemProps } from "types/auth";

type DeliveryNoteCertificationProps = {
  certification: string[];
  certificationNumbers: NonNullable<FirestoreInventoryItemProps["certificationNumbers"]>;
  certificationClaims: NonNullable<FirestoreInventoryItemProps["certificationClaims"]>;
  legacyCertificationNumber: string;
};

const claimText = {
  fsc: {
    "100Percent": "FSC 100 %",
    mixCredit: "FSC Mix Credit",
  },
  pefc: {
    certified: "100 % PEFC Certified",
    origin: "100 % PEFC Origin",
  },
} as const;

export function formatDeliveryNoteCertification({
  certification,
  certificationNumbers,
  certificationClaims,
  legacyCertificationNumber,
}: DeliveryNoteCertificationProps) {
  const certificateNumbers: string[] = [];
  const claims: string[] = [];
  const selected = new Set(certification);

  (["fsc", "pefc", "sbp", "rbp", "ukwas"] as const).forEach((tag) => {
    if (!selected.has(tag)) return;

    const number = certificationNumbers[tag];
    if (number) certificateNumbers.push(number);

    if (tag === "fsc" && certificationClaims.fsc) {
      claims.push(claimText.fsc[certificationClaims.fsc]);
    }
    if (tag === "pefc" && certificationClaims.pefc) {
      claims.push(claimText.pefc[certificationClaims.pefc]);
    }
    if (tag === "sbp") claims.push("SBP Compliant v2");
    if (tag === "rbp") claims.push("RBP Verificeret Biomasse (VEIII)");
  });

  return {
    certificateNumbers: certificateNumbers.join(", ") || legacyCertificationNumber || "-",
    claims: claims.join(", ") || "-",
  };
}
